import CurrencyFormat from "react-currency-format";
import { const_var } from "../../../redux/reducers/reducer";
import { properCase, SummaryRow } from "./Summary";
import React from "react";
import { calcNumOfWalls } from "../../../helpers/building_pricing/wall_pricing/wallPricing.helper";

export const ExtraOptionsSummary = ({ options, extraItemLabel, params, compareParamData, buildingType = "center", extraAddOnArray = [] }) => {
	const isCenterBuilding = buildingType == "center" ? true : false;
	const crossBracingOptions = options?.filter((obj) => obj && (obj?.item_name?.includes("Cross Bracing") || obj?.other_item_name?.includes("Cross Bracing")));
	if (crossBracingOptions?.length == options?.length) {
		return null;
	}
	const certificate = const_var?.post_data?.building?.certificate;

	const checkForLoft = (val) => {
		let findLoftObj = extraAddOnArray.find((obj) => obj?.name?.toLowerCase().includes("loft"));
		if (findLoftObj?.is_checkbox == 2) {
			return <>({const_var.selLoftVal[buildingType]} Feet)</>;
		}
		return null;
	};
	const getSelectedBracing = (value) => {
		if (value?.other_item_name === "Side Cross Bracing" && const_var?.selected_scbracing !== "none" && const_var?.a_p_d_a?.side_cross_bracing) {
			if (value.display_name) {
				return `Side Cross Bracing: ${value.display_name}`;
			}
			const bracing = const_var.a_p_d_a.side_cross_bracing.find((obj) => obj && obj.sheet_name === const_var.selected_scbracing);
			return `Side Cross Bracing: ${bracing?.sheet_label || ""}`;
		}
		if (value?.other_item_name === "End Cross Bracing" && const_var?.selected_ecbracing !== "none" && const_var?.a_p_d_a?.end_cross_bracing) {
			if (value.display_name) {
				return `End Cross Bracing: ${value.display_name}`;
			}
			const bracing = const_var.a_p_d_a.end_cross_bracing.find((obj) => obj && obj.sheet_name === const_var.selected_ecbracing);
			return `End Cross Bracing: ${bracing?.sheet_label || ""}`;
		}
		return "";
	};
	const getQuantityLabel = (value) => {
		const isExtraItem = extraItemLabel.includes(value.item_name?.trim()) || (value.other_item_name === "fourth_center_cost" && value.item_name?.includes("4ft on Center"));
		if (isExtraItem && value.item_quantity === 1) {
			if (value.item_name === "4ft on Center" && (value.item_price === 0 || params?.isDefaultfourFeet) && certificate?.distance_on_center === 4) {
				return "Included";
			}
			return <>Yes {value.is_disabled && value?.is_edit !== true && "(Included)"}</>;
		}
		if (value.is_disabled) {
			return "Included";
		}
		if (value.item_name?.toLowerCase().includes("screws")) {
			return value.item_quantity === 1 ? "Yes" : "No";
		}
		return value.item_quantity;
	};
	const getLabel = (value) => {
		if (value.item_name === "Jtrim") {
			return "Side Jtrim";
		}
		if (value.other_item_name === "overhang" && value.newName) {
			return value.newName;
		}
		let label = value.item_name;
		const showWindLabel = ((params?.m_s_n === 147 && !compareParamData) || compareParamData?.m_s_n === 147) && value.other_item_name === "ground_certificate";
		if (showWindLabel) {
			label += " (Up To 115 MPH Wind)";
		}
		return label;
	};
	return (
		<>
			{!isCenterBuilding && <span className="summary-label sub-txt">Options:</span>}
			<div className="highlight-with-bg">
				{Object.entries(options).map(([key, value]) => {
					if (!value) return null;
					if (value?.other_item_name === "Side Cross Bracing" || value?.other_item_name === "End Cross Bracing") {
						return null;
					}
					const totalEndWall = value?.item_name === "End Jtrim" ? calcNumOfWalls("end", "1") : 0;
					const totalSideWall = value?.item_name !== "End Jtrim" ? calcNumOfWalls("side", "1") : 0;
					if ((value.item_name === "End Jtrim" && totalEndWall === 0) || (value.item_name === "Jtrim" && totalSideWall === 0)) {
						return null;
					}
					const isCrossBracing = value.other_item_name === "Side Cross Bracing" || value.other_item_name === "End Cross Bracing";

					const selectedBracing = getSelectedBracing(value);

					return (
						<div className={"summary-row d-flex justify-content-between repeat-loop"} key={key}>
							<div className={`summary-label ${value.item_name === "lift fee" ? "text-capitalize" : ""}`}>
								{isCrossBracing ? selectedBracing : getLabel(value)}
								{value.other_item_name === "overhang" && value.item_name && !value.item_name.toLowerCase().includes("end") && !value.item_name.toLowerCase().includes("side") && <> (End + Side)</>}
								{(value.other_item_name === "overhang" && value.is_disabled) || value.item_name?.toLowerCase() === "5/12 labor (2/2) fee" ? <span className="dark-span"> (Included)</span> : null}
								{value.other_item_name !== "overhang" && value.item_name !== "Foam Enclosure" && value.item_from !== "extra_add_on" && (
									<>
										: <span className="dark-span">{getQuantityLabel(value)}</span>
									</>
								)}
								{value.item_name?.toLowerCase().includes("loft") && checkForLoft()}
							</div>
							<div className="summary-info">
								<aside className="summary-info-right">
									{value?.item_price != undefined && (
										<></>
										// <CurrencyFormat value={value.item_price} fixedDecimalScale="2" decimalSeparator="." decimalScale="2" displayType={"text"} thousandSeparator={true} prefix={"$"} />
									)}
								</aside>
							</div>
						</div>
					);
				})}
			</div>
		</>
	);
};

export const CrossBracingSummary = ({ options, leanType, mainData }) => {
	return (
		<>
			{Object.entries(options ?? {}).map(([key, value]) => {
				const type = value?.other_item_name;
				if (type !== "Side Cross Bracing" && type !== "End Cross Bracing") {
					return null;
				}
				let bracingName = value.display_name || value.item_name || "";

				if (type === "Side Cross Bracing") {
					bracingName = bracingName.replace("_side", "").replace("Side:", "");
				}
				if (type === "End Cross Bracing") {
					bracingName = bracingName.replace("_end", "").replace("End:", "");
				}
				const selectedBracing = `${type}: ${bracingName}`;
				return <SummaryRow className="summary-row d-flex justify-content-between repeat-loop" key={key} label={selectedBracing} price={value?.item_price ?? 0} />;
			})}
		</>
	);
};

export const ConnectionFeeSummary = ({ summaryViewData, props, showSideWithLean, showItWithZero }) => {
	const isCustomBuilding = props.const_var?.b_o_J_1?.[props.params.p_b_t] === "Custom Buildings";

	return (
		<>
			{summaryViewData?.connection_fee_side != null && ((isCustomBuilding && showSideWithLean) || (showItWithZero.includes(props.params.m_s_n) ? showSideWithLean : summaryViewData.connection_fee_side != 0)) && (
				<SummaryRow label={"Side Connection Fees"} price={summaryViewData?.connection_fee_side ?? 0} />
			)}

			{summaryViewData?.connection_fee_left_front != null && summaryViewData.connection_fee_left_front != 0 && (
				<SummaryRow label={"Left Front Connection Fees"} price={summaryViewData?.connection_fee_left_front ?? 0} />
			)}

			{summaryViewData?.connection_fee_right_front != null && summaryViewData.connection_fee_right_front != 0 && (
				<SummaryRow label={"Right Front Connection Fees"} price={summaryViewData?.connection_fee_right_front ?? 0} />
			)}

			{summaryViewData?.connection_fee_left_back != null && summaryViewData?.connection_fee_left_back != 0 && (
				<SummaryRow label={"Left Back Connection Fees"} price={summaryViewData?.connection_fee_left_back ?? 0} />
			)}

			{summaryViewData?.connection_fee_right_back != null && summaryViewData?.connection_fee_right_back != 0 && (
				<SummaryRow label={"Right Back Connection Fees"} price={summaryViewData?.connection_fee_right_back ?? 0} />
			)}
		</>
	);
};

export const OtherInfoSummary = ({ summaryViewData, props, checkNatCarport }) => {
	if (!props.const_var?.post_data.building?.order_extra_items) return;

	const { electricity, inside_city, installation_ready, surface_level, permit, pdf_price_breakdown, dont_show_processing_fee_pdf, welded_spacer, notched_lip, space_around_building, site_clear_obstacle } =
		props.const_var?.post_data.building?.order_extra_items || {};
	const excludedKeys = ["down_payment_rate", "discount_rate", "grvy_value", "down_payment_discount_rate"];

	return (
		<div className="highlight-with-bg">
			{summaryViewData?.extra_price_cal != undefined &&
				Object.entries(summaryViewData.extra_price_cal).map(([key, value]) => {
					if (!excludedKeys.includes(key)) {
						return <SummaryRow key={key} label={<aside className="summary-info-left">{key.replace(/_/g, " ").charAt(0).toUpperCase() + key.replace(/_/g, " ").slice(1)}</aside>} price={value} />;
					}
				})}

			{!checkNatCarport && (
				<div className={!!props.const_var.loginSession && "d-none"}>
					<SummaryRow
						label={
							<>
								<span className="summary-label-title">Jobsite Level</span>
								{" - "}
								<span className="dark-span">{props.params.job_site_level == "no" ? "No" : "Yes"}</span>
							</>
						}
					/>
				</div>
			)}

			{!checkNatCarport && (
				<div className={!!props.const_var.loginSession && "d-none"}>
					<SummaryRow
						label={
							<>
								<span className="summary-label-title">Electricity Available</span>
								{" - "}
								<span className="dark-span">{props.params.power_avail == "no" ? "No" : "Yes"}</span>
							</>
						}
					/>
				</div>
			)}

			{summaryViewData?.manufacturer != 169 && welded_spacer && !!props.const_var.loginSession && props.ExtrascrmSetting.is_module_name != "inventory" && (
				<SummaryRow
					label={
						<>
							<span className="summary-label-title">Welded Spacer</span>
							{" - "}
							<span className="dark-span">{properCase(welded_spacer)}</span>
						</>
					}
				/>
			)}
			{notched_lip && !!props.const_var.loginSession && props.ExtrascrmSetting.is_module_name != "inventory" && (
				<SummaryRow
					label={
						<>
							<span className="summary-label-title">Notched Lip</span>
							{" - "}
							<span className="dark-span">{properCase(notched_lip)}</span>
						</>
					}
				/>
			)}
			{space_around_building && !!props.const_var.loginSession && props.ExtrascrmSetting.is_module_name != "inventory" && (
				<SummaryRow
					label={
						<>
							<span className="summary-label-title">5ft. Space Around the Building</span>
							{" - "}
							<span className="dark-span">{properCase(space_around_building)}</span>
						</>
					}
				/>
			)}
			{site_clear_obstacle && !!props.const_var.loginSession && props.ExtrascrmSetting.is_module_name != "inventory" && (
				<SummaryRow
					label={
						<>
							<span className="summary-label-title">Site Clear of Obstacles</span>
							{" - "}
							<span className="dark-span">{properCase(site_clear_obstacle)}</span>
						</>
					}
				/>
			)}

			{surface_level && !!props.const_var.loginSession && (
				<SummaryRow
					label={
						<>
							<span className="summary-label-title">Surface Level</span>
							{" - "}
							<span className="dark-span">{properCase(surface_level)}</span>
						</>
					}
				/>
			)}

			{inside_city && !!props.const_var.loginSession && (
				<SummaryRow
					label={
						<>
							<span className="summary-label-title">Inside City Limit</span>
							{" - "}
							<span className="dark-span">{properCase(inside_city)}</span>
						</>
					}
				/>
			)}
			{installation_ready && !!props.const_var.loginSession && (
				<SummaryRow
					label={
						<>
							<span className="summary-label-title">Installation Ready</span>
							{" - "}
							<span className="dark-span">{properCase(installation_ready)}</span>
						</>
					}
				/>
			)}
			{electricity && !checkNatCarport && !!props.const_var.loginSession && (
				<SummaryRow
					label={
						<>
							<span className="summary-label-title">Electricity Available</span>
							{" - "}
							<span className="dark-span">{properCase(electricity)}</span>
						</>
					}
				/>
			)}
			{((!props.const_var.loginSession && summaryViewData?.order_extra_items?.permit && props.const_var?.stateManufacturerAcordingAPI?.[props.params.p_s_n]?.is_permit_show_in_3d) ||
				(props.const_var.loginSession && summaryViewData?.order_extra_items?.permit)) &&
				props.ExtrascrmSetting.is_module_name != "inventory" && (
					<SummaryRow
						label={
							<>
								<span className="summary-label-title">Permit Required</span>
								{" - "}
								<span className="dark-span">{summaryViewData.order_extra_items.permit == "cust_verify" ? "Customer To Verify" : properCase(summaryViewData.order_extra_items.permit)}</span>
							</>
						}
						price={summaryViewData?.order_extra_items?.permit ?? 0}
					/>
				)}

			{pdf_price_breakdown !== "" && pdf_price_breakdown !== null && props.const_var.loginSession ? (
				<div className="summary-row d-flex justify-content-between">
					<div className="summary-label">
						<span className="summary-label-title">Display Price Breakdown in PDF</span>
						{" - "}
						<span className="dark-span">{pdf_price_breakdown == "1" ? "Yes" : "No"}</span>
					</div>
				</div>
			) : (
				""
			)}

			{!!dont_show_processing_fee_pdf && props.const_var.loginSession ? (
				<div className="summary-row d-flex justify-content-between">
					<div className="summary-label">
						<span className="summary-label-title">Credit Card Fee</span>
						{" - "}
						<span className="dark-span">{dont_show_processing_fee_pdf == "1" ? "Included CC Fee in Order" : "Included CC Fee in Invoice only"}</span>
					</div>
					<div className="summary-info"></div>
				</div>
			) : (
				""
			)}

			{props.params.additional_note !== "" && props.const_var.loginSession && (
				<div className="summary-row d-flex justify-content-between">
					<div className="summary-label">
						<span className="summary-label-title">Extra Notes</span>
						{" - "}
						<span className="dark-span">{props.params.additional_note}</span>
					</div>
				</div>
			)}
		</div>
	);
};

export const NotesAndExtraSummary = ({ summaryViewData, props, isUserData }) => {
	const orderExtraItems = summaryViewData?.order_extra_items || {};
	const isOldED = props.const_var.isMultiSelectDrawingOpt === false && isUserData === false;
	const skipKeys = ["has_grvy", "dont_show_processing_fee_pdf", "pdf_price_breakdown", "permit", "additional_note", "description", "labor_per_type", "labor_fee_on"];
	const formatLabel = (key) => {
		let label = key.indexOf("_") > -1 ? key.replace(/_/g, " ") : key;

		label = properCase(label);

		switch (label) {
			case "SurchargeFees":
				return "Surcharge Fees";

			case "Processing Fee":
				return "CC Processing Fee";

			case "Order Permit Fee":
				return "Permit Fee";

			case "Extra Labour":
				return "Extra Labor";

			case "Grvy Value":
				return "Gravy Value";

			default:
				return label;
		}
	};
	return (
		<div className="highlight-with-bg">
			{Object.entries(orderExtraItems).map(([rawKey, value]) => {
				if (value == null || value === "" || value === 0 || value === "no" || value === "yes" || skipKeys.includes(rawKey)) {
					return null;
				}
				let key = formatLabel(rawKey);
				const isEngineerDrawing = rawKey === "engineer_drawings";
				const engineerDrawingName = orderExtraItems["engineer_drawings_name"];
				const displayLabel = isEngineerDrawing && engineerDrawingName && engineerDrawingName !== "None" ? engineerDrawingName : key;
				if (key === "Engineer Drawings Name" || (isEngineerDrawing && isOldED)) {
					return null;
				}

				return <SummaryRow key={rawKey} label={displayLabel} price={value ?? 0} />;
			})}
			{summaryViewData?.lift_type && <SummaryRow label={summaryViewData.lifttype_name} price={summaryViewData.lifttype_price ?? 0} />}
			{summaryViewData.AdditionalCharges.length > 0 &&
				summaryViewData.AdditionalCharges.map((data, index) => {
					return <SummaryRow key={data.name || index} label={data.name} price={data?.price ?? 0} />;
				})}
		</div>
	);
};
